// extracted by mini-css-extract-plugin
export var button = "IconButton-module--button--5a216";